import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { CompanyState } from ".";

export const useCompanyReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.company);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<CompanyState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<CompanyState>;
};
